import React, { useEffect, useState } from 'react';
import {
  DesktopOutlined,
  InfoCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined
} from '@ant-design/icons';
import { Breadcrumb, Layout, Menu, theme, Button } from 'antd';
import { useBreadcrumbs } from '../components/BreadCrumbContext';
import EventsTable from '../components/EventsTable';
import logo from '../assets/logo.png';
import { useMediaQuery } from 'react-responsive'

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
// create a component for side menu ?
const items = [
  getItem('Pending Events', '1', <DesktopOutlined />),
  getItem('More Tools soon...', '2', <InfoCircleOutlined />)
];

const HomePage = () => {
  const [collapsed, setCollapsed] = useState(false);
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumbs();
    const isMobile = useMediaQuery({ maxWidth: 768 });
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
    useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);


  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={value => setCollapsed(value)}
        breakpoint="lg"
        collapsedWidth={isMobile ? 0 : 80}
        width={200}
        trigger={isMobile ? null : undefined} // Hide collapse button on mobile
      >
       <div className="demo-logo-vertical" />
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} />
      </Sider>
      <Layout>
        <Header style={{ 
           display: 'flex',
           padding: isMobile ? '0 10px' : '0 24px', 
           background: colorBgContainer, 
           alignItems: 'center',
            justifyContent: isMobile ? 'flex-start' : 'center'
           }}>
        {isMobile && !collapsed && (
            <Button 
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ marginRight: 16 }}
            />
          )}
          <img src={logo} style={{ height: 35 }} />
          </Header>
        <Content style={{ margin: isMobile ? '0 8px' : '0 16px' }}>
          <Breadcrumb style={{ margin: '16px 0' }} items={breadcrumbs} />
          <div
            style={{
              padding: isMobile ? 12 : 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <EventsTable isMobile={isMobile}/>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          TEOPM ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};
export default HomePage;